module.exports = {
    "widthLimit": "mc6ad38729_widthLimit"
};